import {
    ADD_PROMOCODE_FAIL,
    ADD_PROMOCODE_SUCCESS,
    DELETE_PROMOCODE_FAIL,
    DELETE_PROMOCODE_SUCCESS,
    EXPORT_PROMOCODE_FAIL,
    EXPORT_PROMOCODE_SUCCESS,
    GET_PROMOCODE_DETAILS_FAIL,
    GET_PROMOCODE_DETAILS_SUCCESS,
    GET_PROMOCODE_LISTING_FAIL,
    GET_PROMOCODE_LISTING_SUCCESS,
    RESET_PROMOCODE_ATTACHMENT_STATE,
    RESET_PROMOCODE_STATE,
    UPDATE_PROMOCODE_FAIL,
    UPDATE_PROMOCODE_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    promocodeListing: [],
    promocodeDetails: [],
    addPromocode: [],
    updatePromocode: [],
    deletePromocode: [],
    exportPromocode: [],
    error: [],
}

const Promocode = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_PROMOCODE_LISTING_SUCCESS:
            return {
                ...state,
                promocodeListing: action.payload
            }
        case GET_PROMOCODE_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_PROMOCODE_DETAILS_SUCCESS:
            return {
                ...state,
                promocodeDetails: action.payload
            }
        case GET_PROMOCODE_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_PROMOCODE_SUCCESS:
            return {
                ...state,
                addPromocode: action.payload
            }
        case ADD_PROMOCODE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_PROMOCODE_SUCCESS:
            return {
                ...state,
                updatePromocode: action.payload
            }
        case UPDATE_PROMOCODE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_PROMOCODE_SUCCESS:
            return {
                ...state,
                deletePromocode: action.payload
            }
        case DELETE_PROMOCODE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case EXPORT_PROMOCODE_SUCCESS:
            return {
                ...state,
                exportPromocode: action.payload
            }
        case EXPORT_PROMOCODE_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_PROMOCODE_ATTACHMENT_STATE:
            return {
                ...state,
                exportPromocode: [],
                error: [],
            }
        case RESET_PROMOCODE_STATE:
            return {
                ...state,
                promocodeListing: [],
                promocodeDetails: [],
                addPromocode: [],
                updatePromocode: [],
                deletePromocode: [],
                exportPromocode: [],
                error: [],
            }
        default:
            return state
    }
}

export default Promocode
